/* tslint:disable */
/* eslint-disable */
/**
 * AICare API User
 * CRUD File
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CreateFolderDto
 */
export interface CreateFolderDto {
    /**
     * The title of the file
     * @type {string}
     * @memberof CreateFolderDto
     */
    'name': string;
    /**
     * An optional description for the file
     * @type {string}
     * @memberof CreateFolderDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFolderDto
     */
    'view': CreateFolderDtoViewEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateFolderDto
     */
    'parentFolderId': string;
}

export const CreateFolderDtoViewEnum = {
    All: 'ALL',
    CaregiverProfessional: 'CAREGIVER_PROFESSIONAL',
    CaregiverUser: 'CAREGIVER_USER'
} as const;

export type CreateFolderDtoViewEnum = typeof CreateFolderDtoViewEnum[keyof typeof CreateFolderDtoViewEnum];

/**
 * 
 * @export
 * @interface CreateMinioFileDto
 */
export interface CreateMinioFileDto {
    /**
     * The name of the file
     * @type {string}
     * @memberof CreateMinioFileDto
     */
    'name': string;
    /**
     * An optional description for the file
     * @type {string}
     * @memberof CreateMinioFileDto
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMinioFileDto
     */
    'parentFolderId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMinioFileDto
     */
    'view': CreateMinioFileDtoViewEnum;
    /**
     * 
     * @type {File}
     * @memberof CreateMinioFileDto
     */
    'file': File;
}

export const CreateMinioFileDtoViewEnum = {
    All: 'ALL',
    CaregiverProfessional: 'CAREGIVER_PROFESSIONAL',
    CaregiverUser: 'CAREGIVER_USER'
} as const;

export type CreateMinioFileDtoViewEnum = typeof CreateMinioFileDtoViewEnum[keyof typeof CreateMinioFileDtoViewEnum];

/**
 * 
 * @export
 * @interface DeleteFileBulkDto
 */
export interface DeleteFileBulkDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteFileBulkDto
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface FileDto
 */
export interface FileDto {
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'path': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'status': FileDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FileDto
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof FileDto
     */
    'parentFolderId': number;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'presignedUrl': string;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'type': string;
    /**
     * 
     * @type {Array<FileDto>}
     * @memberof FileDto
     */
    'children': Array<FileDto>;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'view': FileDtoViewEnum;
    /**
     * 
     * @type {string}
     * @memberof FileDto
     */
    'itemType': FileDtoItemTypeEnum;
}

export const FileDtoStatusEnum = {
    Dirty: 'DIRTY',
    Waiting: 'WAITING',
    Accepted: 'ACCEPTED',
    Refused: 'REFUSED'
} as const;

export type FileDtoStatusEnum = typeof FileDtoStatusEnum[keyof typeof FileDtoStatusEnum];
export const FileDtoViewEnum = {
    All: 'ALL',
    CaregiverProfessional: 'CAREGIVER_PROFESSIONAL',
    CaregiverUser: 'CAREGIVER_USER'
} as const;

export type FileDtoViewEnum = typeof FileDtoViewEnum[keyof typeof FileDtoViewEnum];
export const FileDtoItemTypeEnum = {
    Video: 'VIDEO',
    File: 'FILE',
    Folder: 'FOLDER'
} as const;

export type FileDtoItemTypeEnum = typeof FileDtoItemTypeEnum[keyof typeof FileDtoItemTypeEnum];

/**
 * 
 * @export
 * @interface FileFilterTableDto
 */
export interface FileFilterTableDto {
    /**
     * 
     * @type {string}
     * @memberof FileFilterTableDto
     */
    'parentFolderId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileFilterTableDto
     */
    'search'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FileFilterTableDto
     */
    'status'?: string | null;
    /**
     * 
     * @type {FileFilterTableDtoView}
     * @memberof FileFilterTableDto
     */
    'view'?: FileFilterTableDtoView;
    /**
     * 
     * @type {boolean}
     * @memberof FileFilterTableDto
     */
    'softDelete'?: boolean | null;
}
/**
 * @type FileFilterTableDtoView
 * @export
 */
export type FileFilterTableDtoView = FileFilterTableDtoViewOneOf | string;

/**
 * 
 * @export
 * @interface FileFilterTableDtoViewOneOf
 */
export interface FileFilterTableDtoViewOneOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof FileFilterTableDtoViewOneOf
     */
    'in'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FileOrderTableDto
 */
export interface FileOrderTableDto {
    /**
     * 
     * @type {string}
     * @memberof FileOrderTableDto
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileOrderTableDto
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface FileRequestTableDto
 */
export interface FileRequestTableDto {
    /**
     * 
     * @type {number}
     * @memberof FileRequestTableDto
     */
    'take'?: number;
    /**
     * 
     * @type {number}
     * @memberof FileRequestTableDto
     */
    'skip'?: number;
    /**
     * 
     * @type {FileFilterTableDto}
     * @memberof FileRequestTableDto
     */
    'filter': FileFilterTableDto | null;
    /**
     * 
     * @type {Array<FileOrderTableDto>}
     * @memberof FileRequestTableDto
     */
    'orderBy'?: Array<FileOrderTableDto> | null;
}
/**
 * 
 * @export
 * @interface FileResponseTableDto
 */
export interface FileResponseTableDto {
    /**
     * 
     * @type {number}
     * @memberof FileResponseTableDto
     */
    'count': number;
    /**
     * 
     * @type {Array<FileDto>}
     * @memberof FileResponseTableDto
     */
    'data': Array<FileDto> | null;
}

/**
 * FileApi - axios parameter creator
 * @export
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create Item File
         * @summary Create Item File
         * @param {CreateMinioFileDto} createMinioFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerCreate: async (createMinioFileDto: CreateMinioFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMinioFileDto' is not null or undefined
            assertParamExists('fileControllerCreate', 'createMinioFileDto', createMinioFileDto)
            const localVarPath = `/api/v1/file/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMinioFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create Item Folder
         * @summary Create Item Folder
         * @param {CreateFolderDto} createFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerCreateFolder: async (createFolderDto: CreateFolderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFolderDto' is not null or undefined
            assertParamExists('fileControllerCreateFolder', 'createFolderDto', createFolderDto)
            const localVarPath = `/api/v1/file/folder/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete many Item Files
         * @summary Delete many Item Files
         * @param {DeleteFileBulkDto} deleteFileBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerDelete: async (deleteFileBulkDto: DeleteFileBulkDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteFileBulkDto' is not null or undefined
            assertParamExists('fileControllerDelete', 'deleteFileBulkDto', deleteFileBulkDto)
            const localVarPath = `/api/v1/file/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteFileBulkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete knowledge base
         * @summary Delete knowledge base
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerDeleteKnowledgeBase: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/file/kb/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerDownloadFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fileControllerDownloadFile', 'id', id)
            const localVarPath = `/api/v1/file/download/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all items in a folder
         * @summary Get all items in a folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerFind: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('fileControllerFind', 'folderId', folderId)
            const localVarPath = `/api/v1/file/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all items in a folder for table
         * @summary Get all items in a folder for table
         * @param {FileRequestTableDto} fileRequestTableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerFindItemsInFolder: async (fileRequestTableDto: FileRequestTableDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileRequestTableDto' is not null or undefined
            assertParamExists('fileControllerFindItemsInFolder', 'fileRequestTableDto', fileRequestTableDto)
            const localVarPath = `/api/v1/file/browse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileRequestTableDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update status of agent
         * @summary Update status of agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerNotifyAgentCreation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/file/agent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download a file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerPresignedDownloadFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('fileControllerPresignedDownloadFile', 'id', id)
            const localVarPath = `/api/v1/file/presigned/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request Sync Files
         * @summary Request Sync Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerRequestSyncFiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/file/request-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sync Files
         * @summary Sync Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerSyncFiles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/file/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 * @export
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * Create Item File
         * @summary Create Item File
         * @param {CreateMinioFileDto} createMinioFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerCreate(createMinioFileDto: CreateMinioFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerCreate(createMinioFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create Item Folder
         * @summary Create Item Folder
         * @param {CreateFolderDto} createFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerCreateFolder(createFolderDto: CreateFolderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerCreateFolder(createFolderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerCreateFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete many Item Files
         * @summary Delete many Item Files
         * @param {DeleteFileBulkDto} deleteFileBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerDelete(deleteFileBulkDto: DeleteFileBulkDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerDelete(deleteFileBulkDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete knowledge base
         * @summary Delete knowledge base
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerDeleteKnowledgeBase(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerDeleteKnowledgeBase(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerDeleteKnowledgeBase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerDownloadFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerDownloadFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerDownloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all items in a folder
         * @summary Get all items in a folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerFind(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerFind(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerFind']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all items in a folder for table
         * @summary Get all items in a folder for table
         * @param {FileRequestTableDto} fileRequestTableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerFindItemsInFolder(fileRequestTableDto: FileRequestTableDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponseTableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerFindItemsInFolder(fileRequestTableDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerFindItemsInFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update status of agent
         * @summary Update status of agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerNotifyAgentCreation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerNotifyAgentCreation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerNotifyAgentCreation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download a file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerPresignedDownloadFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerPresignedDownloadFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerPresignedDownloadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request Sync Files
         * @summary Request Sync Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerRequestSyncFiles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerRequestSyncFiles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerRequestSyncFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sync Files
         * @summary Sync Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerSyncFiles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerSyncFiles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerSyncFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileApi - factory interface
 * @export
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * Create Item File
         * @summary Create Item File
         * @param {CreateMinioFileDto} createMinioFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerCreate(createMinioFileDto: CreateMinioFileDto, options?: any): AxiosPromise<FileDto> {
            return localVarFp.fileControllerCreate(createMinioFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Create Item Folder
         * @summary Create Item Folder
         * @param {CreateFolderDto} createFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerCreateFolder(createFolderDto: CreateFolderDto, options?: any): AxiosPromise<FileDto> {
            return localVarFp.fileControllerCreateFolder(createFolderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete many Item Files
         * @summary Delete many Item Files
         * @param {DeleteFileBulkDto} deleteFileBulkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerDelete(deleteFileBulkDto: DeleteFileBulkDto, options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerDelete(deleteFileBulkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete knowledge base
         * @summary Delete knowledge base
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerDeleteKnowledgeBase(options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerDeleteKnowledgeBase(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerDownloadFile(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerDownloadFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all items in a folder
         * @summary Get all items in a folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerFind(folderId: string, options?: any): AxiosPromise<FileResponseTableDto> {
            return localVarFp.fileControllerFind(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all items in a folder for table
         * @summary Get all items in a folder for table
         * @param {FileRequestTableDto} fileRequestTableDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerFindItemsInFolder(fileRequestTableDto: FileRequestTableDto, options?: any): AxiosPromise<FileResponseTableDto> {
            return localVarFp.fileControllerFindItemsInFolder(fileRequestTableDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update status of agent
         * @summary Update status of agent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerNotifyAgentCreation(options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerNotifyAgentCreation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download a file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerPresignedDownloadFile(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerPresignedDownloadFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Request Sync Files
         * @summary Request Sync Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerRequestSyncFiles(options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerRequestSyncFiles(options).then((request) => request(axios, basePath));
        },
        /**
         * Sync Files
         * @summary Sync Files
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerSyncFiles(options?: any): AxiosPromise<void> {
            return localVarFp.fileControllerSyncFiles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 * @export
 * @class FileApi
 * @extends {BaseAPI}
 */
export class FileApi extends BaseAPI {
    /**
     * Create Item File
     * @summary Create Item File
     * @param {CreateMinioFileDto} createMinioFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerCreate(createMinioFileDto: CreateMinioFileDto, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerCreate(createMinioFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create Item Folder
     * @summary Create Item Folder
     * @param {CreateFolderDto} createFolderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerCreateFolder(createFolderDto: CreateFolderDto, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerCreateFolder(createFolderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete many Item Files
     * @summary Delete many Item Files
     * @param {DeleteFileBulkDto} deleteFileBulkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerDelete(deleteFileBulkDto: DeleteFileBulkDto, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerDelete(deleteFileBulkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete knowledge base
     * @summary Delete knowledge base
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerDeleteKnowledgeBase(options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerDeleteKnowledgeBase(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a file
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerDownloadFile(id: string, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerDownloadFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all items in a folder
     * @summary Get all items in a folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerFind(folderId: string, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerFind(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all items in a folder for table
     * @summary Get all items in a folder for table
     * @param {FileRequestTableDto} fileRequestTableDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerFindItemsInFolder(fileRequestTableDto: FileRequestTableDto, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerFindItemsInFolder(fileRequestTableDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update status of agent
     * @summary Update status of agent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerNotifyAgentCreation(options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerNotifyAgentCreation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download a file
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerPresignedDownloadFile(id: string, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerPresignedDownloadFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request Sync Files
     * @summary Request Sync Files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerRequestSyncFiles(options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerRequestSyncFiles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sync Files
     * @summary Sync Files
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FileApi
     */
    public fileControllerSyncFiles(options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerSyncFiles(options).then((request) => request(this.axios, this.basePath));
    }
}



